import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-1540">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/8gPVfgFKnKmQ5Gy26EKfHX/GSDpic1.webp')] opacity-15 bg-cover bg-center mix-blend-overlay" data-id="element-1541"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy to-navy/80" data-id="element-1542"></div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-1543">
        <div className="anim-on-scroll" data-id="element-1544">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-1545">
            Ready to Upgrade Your Bathroom With Custom Shower Glass?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-1546">
            Whether you want a frameless shower door, Euro glass enclosure,
            sliding tub door or custom walk-in shower panel, Kosin's Glass can
            help you choose the right glass, hardware and installation plan.
          </p>
          <div className="flex items-start sm:items-center justify-center gap-2 mb-8 max-w-2xl mx-auto" aria-label="5-star rated" data-id="element-1547">
            <span className="flex shrink-0 mt-1 sm:mt-0" aria-hidden="true" data-id="element-1548">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 fill-amber-400" viewBox="0 0 24 24" data-id="element-1549">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-1550" />
                </svg>)}
            </span>
            <span className="text-sm text-blue-100 font-medium text-left" data-id="element-1551">
              Trusted by Southeast Michigan homeowners for custom shower doors,
              frameless enclosures and professional installation.
            </span>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1552">
            <a href="#quote-form" className="w-full sm:w-auto bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-1553">
              Request a Free In-Home Shower Quote
              <ArrowRight className="w-5 h-5" data-id="element-1554" />
            </a>
            <a href="tel:5175457772" className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white font-semibold py-4 px-8 rounded-xl transition-colors flex items-center justify-center gap-2 backdrop-blur-sm" data-id="element-1555">
              <Phone className="w-5 h-5" data-id="element-1556" />
              Call 517-545-7772
            </a>
          </div>
        </div>
      </div>
    </section>;
}